
            const data = {"name":"tick","data":{"width":"13","height":"9","viewBox":"0 0 13 9","data":"<path pid=\"0\" fill-rule=\"evenodd\" _fill=\"#00AFA5\" d=\"m.634 5.477 4.093 3.411L12.329.117\"/>","originalColors":[{"type":"fill","color":"#00AFA5"}],"stopColors":[]}}
        
                module.exports = data
                